import { Badge } from '@/components/ui/badge';
import { ProjetoStatus } from '@/types';

interface Props {
  status: ProjetoStatus;
}

const statusConfig: Record<ProjetoStatus, { label: string; className?: string; variant?: 'secondary' | 'destructive' }> = {
  em_edicao: { label: 'Em Edição', variant: 'secondary' },
  ag_aprovacao: { label: 'Ag. Aprovação', className: 'bg-yellow-100 text-yellow-800 border-yellow-200' },
  em_andamento: { label: 'Em Andamento', className: 'bg-blue-100 text-blue-800 border-blue-200' },
  ag_validacao: { label: 'Ag. Validação', className: 'bg-purple-100 text-purple-800 border-purple-200' },
  finalizado: { label: 'Finalizado', className: 'bg-green-100 text-green-800 border-green-200' },
  reprovado: { label: 'Reprovado', variant: 'destructive' },
};

export function ProjetoStatusBadge({ status }: Props) {
  const config = statusConfig[status];

  if (config.variant) {
    return <Badge variant={config.variant}>{config.label}</Badge>;
  }

  return (
    <Badge variant="outline" className={config.className}>
      {config.label}
    </Badge>
  );
}
